// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, enumOf } from "@altostra/type-validations";
import { string, number } from "@altostra/type-validations/lib/primitives";

import sharedConstants from "@lib/shared_constants.json";

export const isWhatsAppConsumptionResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      waba: string,
      app_group: string,
      category: enumOf(
        sharedConstants.WHATS_APP.MESSAGE_CATEGORIES.MARKETING,
        sharedConstants.WHATS_APP.MESSAGE_CATEGORIES.UTILITY,
        sharedConstants.WHATS_APP.MESSAGE_CATEGORIES.AUTHENTICATION,
        sharedConstants.WHATS_APP.MESSAGE_CATEGORIES.SERVICE,
        sharedConstants.WHATS_APP.MESSAGE_CATEGORIES.MARKETING_LITE
      ),
      region: string,
      billable_sends: number,
      country: string,
      credit_ratio: number,
      credits_used: number,
      last_updated_at: number,
    })
  ),
});
